const meta = {
  'source-plugins': 'Source',
  'destination-plugins': 'Destination',
  'test-settings': 'Test plugin settings',
};

export default meta;
